import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSession from 'vue-session'
import VueSimpleAlert from "vue-simple-alert";

Vue.config.productionTip = false;
Vue.use(VueSession);
Vue.use(VueSimpleAlert)

const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
